import { plainToClassFromExist } from "class-transformer"

export abstract class BaseDTO<T> {
  constructor(props?: { [K in keyof T]: T[K] }) {
    plainToClassFromExist(this, props)
  }
}
